import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import BookingDetails from '../../components/Booking/BookingDetails';
import RestUtilities from '../../services/RestUtilities';
import { Grid, Typography, Box } from '@mui/material';
import { useSetRecoilState } from 'recoil';
import { loadingState, toastState } from '../../state/RecoilState';
import { Booking, Enquiry } from '../../@types/api';
import dayjs from 'dayjs';
import { bookingStatus, dbDayFormat, dbTimeFormat } from '../../Constants';

const CreateBooking = () => {
  const { id } = useParams();
  const setToast = useSetRecoilState(toastState);
  const setLoading = useSetRecoilState(loadingState);
  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState<Enquiry | undefined>(undefined);
  const [booking, setBooking] = useState<Booking | undefined>(undefined);

  useEffect(() => {
    const getEnquiry = async () => {
      setLoading(true);
      const res = await RestUtilities.get(`/api/enquiry/Get/${id}`);
      if (res.ok) {
        setEnquiry(res.content.enquiry);
        setBooking({
          artistId: -1,
          clientId: res.content.enquiry.clientId,
          eventDate: dayjs(res.content.enquiry.eventDate),
          entStartTime: dayjs(res.content.eventStartTime),
          entEndTime: dayjs(res.content.eventEndTime),
          location: res.content.enquiry.location,
          venueName: res.content.enquiry.venueName,
          statusId: bookingStatus.OPEN,
          eventTypeId: 1,
        } as Booking);
      }
      setToast('Enquiry Loaded');
      setLoading(false);
    };
    if (id) {
      getEnquiry();
    }
  }, [id, setLoading, setToast]);

  const saveChanges = async (updatedBooking: Booking) => {
    const data = {
      ...updatedBooking,
      eventDate: updatedBooking.eventDate.format(dbDayFormat),
      entStartTime: updatedBooking.entStartTime.format(dbTimeFormat),
      entEndTime: updatedBooking.entEndTime.format(dbTimeFormat),
    };
    var res = await RestUtilities.post(`api/booking/post/${id}`, data);
    if (res.ok) {
      setToast('Booking created');
      navigate(`/booking/edit/${res.content.bookingId}`);
    } else {
      setToast('Something went wrong! Booking was not created');
    }
  };

  return (
    <Box>
      {enquiry && (
        <>
          <Typography variant='h5' color='primary'>
            Create Booking from Enquiry ID: {enquiry?.enquiryId}
          </Typography>
          <Grid container spacing={2}>
            <Grid item>
              {booking && (
                <BookingDetails
                  booking={booking}
                  saveChanges={saveChanges}
                  buttonText='Create Booking'
                />
              )}
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};
export default CreateBooking;
